import { copyJsonObject } from "../commonUtils";
import {
  convert_Timestamp_To_Luxon,
  getFormattedTimeStamp,
  isoDateStringToClientDateStringFormat,
} from "../dateTimeFormatter";
import { convertTempAssignmentSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime } from "../timeZoneService";

export const getScrubbedTempAssignmentSnapshots = (tempAssignmentSnapshots, station) => {
  let scrubbedTempAssignmentSnapshots = [];

  for (let i = 0; i < tempAssignmentSnapshots.length; i++) {
    scrubbedTempAssignmentSnapshots.push(getScrubbedTempAssignmentSnapshot(tempAssignmentSnapshots[i], station));
  }

  return scrubbedTempAssignmentSnapshots;
};

export const getScrubbedTempAssignmentSnapshot = (tempAssignmentSnapshot, station) => {
  let scrubbedTempAssignmentSnapshot = copyJsonObject(tempAssignmentSnapshot);
  scrubbedTempAssignmentSnapshot = convertTempAssignmentSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(
    scrubbedTempAssignmentSnapshot,
    station
  );
  scrubbedTempAssignmentSnapshot.id = scrubbedTempAssignmentSnapshot.referenceNumber;

  return scrubbedTempAssignmentSnapshot;
};

export const convertIncomingTaedEventToSnapshotFormat = (tempAssignmentEvent, station) => {
  const lastUpdatedDate = tempAssignmentEvent.customCreatedAt
    ? tempAssignmentEvent.customCreatedAt
    : tempAssignmentEvent.createdAt;
  let eventInSnapshotFormat = {
    id: tempAssignmentEvent.referenceNumber,
    homeStation: tempAssignmentEvent.homeStation,
    tempStation: tempAssignmentEvent.tempStation,
    eid: tempAssignmentEvent.eid,
    empFirstName: tempAssignmentEvent.firstName,
    empLastName: tempAssignmentEvent.lastName,
    workgroup: tempAssignmentEvent.workgroup,
    lastUpdatedDate: lastUpdatedDate,
    referenceNumber: tempAssignmentEvent.referenceNumber,
    startDate: tempAssignmentEvent.startDate,
    endDate: tempAssignmentEvent.endDate,
    status: tempAssignmentEvent.status,
    baseSchedule: tempAssignmentEvent.baseSchedule,
    contactNumber: tempAssignmentEvent.contactNumber,
    searchFormat: {
      lastUpdated: getFormattedTimeStamp(convert_Timestamp_To_Luxon(lastUpdatedDate, station)),
      employee: `${tempAssignmentEvent.lastName}, ${tempAssignmentEvent.firstName} (${tempAssignmentEvent.eid})`,
      startDate: isoDateStringToClientDateStringFormat(tempAssignmentEvent.startDate),
      endDate: isoDateStringToClientDateStringFormat(tempAssignmentEvent.endDate),
    },
  };
  eventInSnapshotFormat =
    convertTempAssignmentSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(eventInSnapshotFormat);
  return eventInSnapshotFormat;
};
